<template>
  <fieldset id="sw-portal-task-form">
    <section>
      <header
        v-if="!hideHeader"
      >
        Задача
      </header>

      <VTextarea
        ref="taskTitleInput"
        label="Заголовок задачи"
        layout="vertical"
        required
        v-model="localSWPortalTask.title"
      />

      <VSelectV2
        v-model="localSWPortalTask.priority"
        label="Приоритет"
        layout="vertical"
        :data="SWPortalTasksService.priorityOptions"
        required
      />

      <VTextarea
        ref="taskBodyInput"
        v-model="localSWPortalTask.content"
        label="Требуемый результат"
        layout="vertical"
        :min-height="250"
        :disabled="isLoading"
        required
      />
    </section>

    <hr>

    <section class="members">
      <VSwitch
        v-model="localSWPortalTask.isFromMoscowSellers"
        theme="slider"
        checked-label="От поставщиков МСК"
        unchecked-label="От местных поставщиков и других регионов (кроме МСК)"
      />

      <header>Исполнители:</header>

      <ul>
        <li
          v-for="({id, name}, index) in localSWPortalTask.performers"
          :key="'perform' + id"
        >
          <span>{{ Number(index) + 1 }}) {{ name }}</span>

          <VButton
            material="delete"
            :disabled="isLoading"
            @click="removeEmployee('performers', index)"
          />
        </li>
      </ul>

      <footer>
        <VSelect
          v-model="performersInput"
          placeholder="Введите ФИО сотрудника"
          layout="vertical"
          :disabled="isLoading"
          :search-function="SWPortalTasksService.getListEmployees"
        />

        <VButton
          theme="primary"
          :disabled="performersInput === null"
          @click="addEmployee('performers')"
        >
          <template #icon>
            <VIcon material="add" />
          </template>
        </VButton>
      </footer>
    </section>

    <hr>

    <section class="members">
      <header>Наблюдатели:</header>

      <ul>
        <li
          v-for="({id, name}, index) in localSWPortalTask.watchers"
          :key="'watch' + id"
        >
          <span>{{ Number(index) + 1 }}) {{ name }}</span>

          <VButton
            material="delete"
            :disabled="isLoading"
            @click="removeEmployee('watchers', index)"
          />
        </li>
      </ul>

      <footer>
        <VSelect
          v-model="watchersInput"
          placeholder="Введите ФИО сотрудника"
          layout="vertical"
          :disabled="isLoading"
          :search-function="SWPortalTasksService.getListEmployees"
        />

        <VButton
          theme="primary"
          :disabled="watchersInput === null"
          @click="addEmployee('watchers')"
        >
          <template #icon>
            <VIcon material="add" />
          </template>
        </VButton>
      </footer>
    </section>
  </fieldset>
</template>

<style lang="scss" src="./SWPortalTaskForm.scss" />

<script lang="ts">

import type TransportOrder from '@/domains/TransportOrders/TransportOrder';

import SWPortalTask         from '@/domains/SWPortalTask/SWPortalTask';
import SWPortalTasksService from '@/domains/SWPortalTask/SWPortalTasksService';

export default defineComponent({
  name: 'SWPortalTaskForm',

  props: {
    transportOrder: {
      type:    Object as PropType<TransportOrder>,
      default: null,
    },
    swPortalTask: {
      type:    Object as PropType<SWPortalTask>,
      default: null,
    },
    hideHeader: {
      type:    Boolean,
      default: false,
    },
  },

  emits: ['create'],

  setup() {
    return {
      SWPortalTasksService,
    };
  },

  data() {
    let localSWPortalTask: SWPortalTask;

    if (this.swPortalTask) {
      localSWPortalTask = this.swPortalTask;
    } else {
      localSWPortalTask = SWPortalTask.fromTransportOrder(this.transportOrder);
    }

    return {
      localSWPortalTask,
      isLoading:       false,
      performersInput: null,
      watchersInput:   null,
    };
  },

  methods: {
    addEmployee(type) {
      const employees   = this.localSWPortalTask[type];
      const inputVal    = `${type}Input`;
      const newEmployee = { ...this[inputVal] };

      /** проверяем есть этот сотрудник в списке перед добавлением */
      const isDuplicate = employees.some(employee => employee.id === newEmployee.id);
      if (!isDuplicate) {
        employees.push(newEmployee);
        this.localSWPortalTask[type] = employees;
      }
      this[inputVal] = null;
    },

    removeEmployee(type, index) {
      const employees = this.localSWPortalTask[type];
      employees.splice(index, 1);
      this.localSWPortalTask[type] = employees;
    },
  },

});
</script>
